export function createImage(width?: number, height?: number): HTMLImageElement {
	return new Image(width, height);
}
